import React from 'react';
import { useRole } from '../../contexts/RoleContext';
import { Autocomplete, TextField } from '@mui/material';

const RoleSwitcher = ({ style = {} }) => {
  const { userRoles, activeRole, switchRole, isLoading } = useRole();

  if (isLoading) {
    return <div style={{ padding: '8px', color: '#666' }}>Loading roles...</div>;
  }

  if (!userRoles || userRoles.length === 0) {
    return null;
  }

  // Always show dropdown if roles exist (even if only one role)
  // This allows users to see their current role and switch if they have multiple roles

  const roleOptions = userRoles.map(role => ({
    label: role.name || `Role ${role.id}`,
    value: role.id,
    role: role
  }));

  const selectedOption = activeRole ? roleOptions.find(opt => opt.value === activeRole.id) : null;

  const handleRoleChange = (event, newValue) => {
    if (newValue && newValue.value) {
      switchRole(newValue.value);
    }
  };

  return (
    <Autocomplete
      options={roleOptions}
      getOptionLabel={(option) => option.label || ""}
      value={selectedOption}
      onChange={handleRoleChange}
      renderInput={(params) => (
        <TextField
          className="input-border"
          {...params}
          placeholder="Select Role"
          variant="outlined"
          size="small"
          style={{ width: '100%', ...style }}
        />
      )}
      style={{ width: '100%', ...style }}
      disableClearable
    />
  );
};

export default RoleSwitcher;

